import * as React from 'react';

import { SearchCriteriaContext } from 'stores/contexts';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export interface SearchCriteriaProviderProps {
  searchCriteria: SearchCriteriaModel;
}

export const SearchCriteriaProvider: React.FC<SearchCriteriaProviderProps> = ({ children, searchCriteria }) => (
  <SearchCriteriaContext.Provider value={searchCriteria}>{children}</SearchCriteriaContext.Provider>
);
